import cx from 'classnames'
import React, { useEffect } from 'react'

import { post } from '@js/common/api'
import { getTestParam } from '@js/common/utils'

import LocationFinderBVer from '@f/components/LocationFinder'
import LocationFinderBackup from '@f/components/LocationFinder/LocationFinderBackup'
import CTA from '@f/elements/CTA'

import { errorLogger } from '@f-fertighaus/utils/errorLogger'
const isBVersionTest = getTestParam('NR-10472_maps_api_v2') === 'B'
const LocationFinder = isBVersionTest
  ? LocationFinderBVer
  : LocationFinderBackup

const LocationChange = props => {
  const updateLocation = location => {
    props.actions.updateLocation(location)
    try {
      post('users/current', {
        ua_delivery_region_verbose: location
      })
    } catch (e) {
      errorLogger(e)
    }
  }

  useEffect(() => {
    props.actions.update_wtValue({ value: 'delivery-region-input' })
  }, [])

  const vendor = props.data.selected_instances.vendors[0]
  const isConversionFunnel = Boolean(props.funnelVariant)
  const { location } = props.data
  const postcodeMatches =
    location.postcode &&
    vendor?.delivery_regions.indexOf(location.postcode) >= 0

  let feedbackMessage = null
  if (location.postcode) {
    if (postcodeMatches) {
      feedbackMessage = (
        <div className='[ f-t-body f-c-fo-suc400 f-m-t-010 ]'>
          Dieser Anbieter baut hier
        </div>
      )
    } else {
      feedbackMessage = (
        <div className='[ f-t-body f-c-fo-err f-m-t-010 ]'>
          Dieser Anbieter baut nicht hier
        </div>
      )
    }
  }

  return (
    <div
      className={cx(
        'RequestWizard-form-wrapper',
        isConversionFunnel &&
          'RequestWizard-form-wrapper--HDP_conversion-funnel f-p-b-040'
      )}>
      <div className='RequestWizard-top is-location'>
        <div className='RequestWizard-heading'>
          <div className='[ f-t-tmedium f-c-fo-pri f-t-centre f-p-h-080:m ]'>
            Wo möchten Sie bauen?
          </div>
          <div className='[ f-t-body f-c-fo-pri f-t-centre f-m-t-005 f-p-h-080:m ]'>
            Bitte Bauort angeben.
          </div>
        </div>

        <div className='RequestWizard-content'>
          <div className='[ f-t-centre ]'>
            <div data-sel='ipt-bo'>
              <LocationFinder
                onChange={updateLocation}
                className='[ f-t-left ]'
              />
            </div>
            {feedbackMessage}
            {postcodeMatches && (
              <CTA
                type='block-primary'
                tag='button'
                data-sel='btn-cta'
                className='[ f-m-t-020 ]'
                onClick={props.actions.subStepRedirect}>
                Kostenlose Infos anfordern
              </CTA>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LocationChange
